import { userProfileHttpClient } from '@/api/userProfile/client';
import {
  UserFilterCreateRequest,
  UserFilterCreateResponse,
  UserFilterListResponse,
  UserFilterDetailResponse,
  UserFilterUpdateRequest,
  UserFilterUpdateResponse,
  UserFilterDeleteResponse,
} from '@/models/user/userFilter';

export const UserFilterApiService = {
  createFilter: (payload: UserFilterCreateRequest) =>
    userProfileHttpClient.post<UserFilterCreateResponse>('/filters', payload),

  getFilters: () => userProfileHttpClient.get<UserFilterListResponse>('/filters'),

  getFilterById: (filterId: string) =>
    userProfileHttpClient.get<UserFilterDetailResponse>(`/filters/${encodeURIComponent(filterId)}`),

  updateFilter: (filterId: string, payload: UserFilterUpdateRequest) =>
    userProfileHttpClient.put<UserFilterUpdateResponse>(`/filters/${encodeURIComponent(filterId)}`, payload),

  deleteFilter: (filterId: string) =>
    userProfileHttpClient.delete<UserFilterDeleteResponse>(`/filters/${encodeURIComponent(filterId)}`),
};
